// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Ghww","container":"styles_container__8b3VH","title":"styles_title__JNFCR","wrapper":"styles_wrapper__3QJjq","answer":"styles_answer__BgnZf"};